var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000111162793616911217140000016220028059004234655_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FCF7CA;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.1,13.1h-7.4l-0.9,5.1c1.5-0.8,2.8-1.2,4.1-1.2c1,0,1.9,0.2,2.8,0.6s1.6,0.9,2.3,1.5 c0.7,0.7,1.2,1.5,1.5,2.4c0.4,0.9,0.6,1.9,0.6,2.9c0,1.5-0.3,2.9-1,4.1c-0.7,1.2-1.6,2.2-2.9,3c-1.3,0.7-2.8,1.1-4.4,1.1 c-1.9,0-3.4-0.3-4.5-1s-2-1.5-2.5-2.4c-0.5-0.9-0.7-1.7-0.7-2.3c0-0.4,0.2-0.8,0.5-1.2c0.3-0.4,0.8-0.5,1.3-0.5 c0.9,0,1.5,0.5,2,1.5c0.4,0.9,1,1.6,1.7,2.2c0.7,0.5,1.5,0.8,2.4,0.8c0.8,0,1.5-0.2,2.1-0.6c0.6-0.4,1.1-1,1.4-1.7s0.5-1.6,0.5-2.5 c0-1-0.2-1.9-0.5-2.6s-0.8-1.2-1.4-1.6s-1.3-0.5-2-0.5c-0.9,0-1.5,0.1-1.9,0.3c-0.4,0.2-0.9,0.6-1.7,1.1s-1.3,0.8-1.8,0.8 c-0.5,0-1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0,0,0.1-0.4,0.2-1.1L15,12c0.1-0.9,0.4-1.6,0.8-1.9c0.4-0.4,1-0.6,1.9-0.6H26 c1.6,0,2.4,0.6,2.4,1.9c0,0.5-0.2,1-0.6,1.3C27.4,12.9,26.8,13.1,26.1,13.1L26.1,13.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb5);
export default __webpack_public_path__ + "static/media/Tb5.5cc824669318fdd66a3c07164a5fb245.svg";
export { ForwardRef as ReactComponent };